__turbopack_context__.v({
  "codeInput": "index-module__axAzja__codeInput",
  "codeInputContainer": "index-module__axAzja__codeInputContainer",
  "container": "index-module__axAzja__container",
  "countdown": "index-module__axAzja__countdown",
  "description": "index-module__axAzja__description",
  "email": "index-module__axAzja__email",
  "error": "index-module__axAzja__error",
  "resendButton": "index-module__axAzja__resendButton",
  "resendContainer": "index-module__axAzja__resendContainer",
  "resendLink": "index-module__axAzja__resendLink",
  "spin": "index-module__axAzja__spin",
  "spinner": "index-module__axAzja__spinner",
  "verifyingStatus": "index-module__axAzja__verifyingStatus",
});
